import React, { Component } from 'react'
import "./policyinfo.scss"
import Header from '../../components/Header/header'
import Footer from '../../components/Footer/footer'
import { getApiPolicyDetail } from '../../axios/api'
import { UrlSearch } from '../../axios/localstorage'

export default class policyinfo extends Component {

    state = {
        content:``,
        data:{
            attachments:[]
        },
    }

    componentWillMount(){
        window.scroll(0,0);

        let id = UrlSearch('id');

        this.getInfo(id);
    }


    getInfo=(id)=>{
        let param = {
            id
        }

        getApiPolicyDetail(param)
        .then( req =>{
            if(req.data.code === 1){
                let data = req.data.data;
                this.setState({
                    data
                })
            }
        }).catch( err =>{
            console.error(err);
        })
    }


    gotoPage=(page)=>{
        this.props.history.push(page);
    }

    render() {
        return (
            <div className='policyinfo'>
                <Header type={2} />
                <div className='cen'>
                    <div className='main'>
                        <div className='name'>
                            <p>当前位置：</p>
                            <p className='i_point' onClick={()=>{this.gotoPage('/')}}>首页</p>
                            <img alt="" src="/www/assets/imgs/xiaji.png" />
                            <p className='i_point' onClick={()=>{this.gotoPage('/policy')}}>科创政策</p>
                            <img alt="" src="/www/assets/imgs/xiaji.png" />
                            <p>政策详情</p>
                        </div>

                        <div className='box'>
                            <div className='left'>
                                <div className='top'>
                                    <h2>{this.state.data.title}</h2>
                                    <div className='text'>
                                        <div>
                                            <p>项目类别：{this.state.data.qualification}</p>
                                            <p>新闻类型：{this.state.data.plate}</p>
                                        </div>
                                        <div>
                                            <p>发布机构：{this.state.data.dept}</p>
                                            <p>发文日期：{this.state.data.publishTime}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="cont" dangerouslySetInnerHTML={{
                                    __html: this.state.data.content
                                }}></div>
                                <div className='bom'>
                                    <h1>附件：</h1>
                                    {
                                        this.state.data.attachments.map((item,index)=>{
                                            return <a className="btn" key={index} href={item.path} download={item.name}>{item.name}</a>
                                        })
                                    }
                                    
                                </div>
                            </div>
                            <div className='right' hidden>
                                <div className='rbox'>
                                    <div className='rname'>
                                        <img alt="" src="/www/assets/imgs/xiangqing-biaoti.png" />
                                        <p>相关政策</p>
                                    </div>
                                    <div className='text'>
                                        <p>2021年四季度全市科技型企业培育情况最新报告</p>
                                        <p>2021年四季度全市科技型企业培育情况最新报告</p>
                                        <p>2021年四季度全市科技型企业培育情况最新报告</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
